import { create } from 'zustand';
import { HttpError } from 'src/api/common/error/HttpError';

type WaErrorState = {
  errors: HttpError[];
  serverCommunicationErrorExists: boolean;
  addError: (error: HttpError) => void;
  clearErrors: () => void;
  setServerCommunicationError: (serverCommunicationErrorExists: boolean) => void;
};

export const useWaErrorStore = create<WaErrorState>((set) => ({
  errors: [],
  serverCommunicationErrorExists: false,
  addError: (error) =>
    set((state) => ({
      errors: [...state.errors, error],
    })),
  clearErrors: () => set({ errors: [] }),
  setServerCommunicationError: (serverCommunicationErrorExists) =>
    set({ serverCommunicationErrorExists }),
}));
